export default __webpack_public_path__ + "static/media/prepareImg.c245219e.jpg";